// Profile UI Component
import { getCurrentUser } from '../auth.js';

/**
 * Show user profile
 */
export function showProfile() {
    const currentUser = getCurrentUser();

    if (!currentUser) {
        alert('Vous devez être connecté');
        return;
    }

    const modal = document.createElement('div');
    modal.className = 'modal';
    modal.innerHTML = `
    <div class="modal-content profile-modal">
      <div class="modal-header">
        <h3>👤 Mon Profil</h3>
        <button class="close-btn">&times;</button>
      </div>
      <div class="modal-body">
        <div class="profile-content">
          <img 
            src="${currentUser.photoURL || 'https://ui-avatars.com/api/?name=' + encodeURIComponent(currentUser.displayName || currentUser.email)}" 
            alt="Profile"
            class="profile-avatar"
          />
          <div class="profile-info">
            <h4>${currentUser.displayName || 'Anonymous'}</h4>
            <p>${currentUser.email}</p>
            <p class="profile-meta">Membre depuis ${new Date(currentUser.metadata.creationTime).toLocaleDateString('fr-FR')}</p>
          </div>
        </div>
      </div>
    </div>
  `;

    document.body.appendChild(modal);

    // Close handlers
    modal.querySelector('.close-btn').addEventListener('click', () => modal.remove());
    modal.addEventListener('click', (e) => {
        if (e.target === modal) modal.remove();
    });
}
